export const MODAL_VISIBILITY_SHOW = 'MODAL_VISIBILITY_SHOW'
export const MODAL_VISIBILITY_HIDDEN = 'MODAL_VISIBILITY_HIDDEN'